<template>
  <section class="section" id="root">
    <div class="header">
      <div class="backBtn" v-on:click="goBack"></div>
      <h4 v-if="st < 3">Masukan data diri</h4>
      <h4 v-else-if="st === 3">Body Mass Index</h4>
      <h4 v-else-if="st === 4">TDEE</h4>
      <h4 v-else>Upload foto</h4>
    </div>
    <div :class="{charPreview: true, st2: st === 2, st3: st === 3,
      nunu: selectedChar === 'nunu', lili: selectedChar === 'lili',
      normal: bmiType === 'normal', gemuk: bmiType === 'gemuk',
      kurus: bmiType === 'kurus'}" v-if="st < 4">
      <div class="head"></div>
      <div class="face"></div>
      <div class="body"></div>
    </div>
    <form v-on:submit.prevent="handleSubmit"
      v-else-if="st === 4" class="st4">
      <div class="aboCnt">
        BMR (Kebutuhan Kalori Harianmu)
        <span>{{bmr}} kalori</span>
      </div>
      <div class="tdeeCnt">
        <h4>TDEE: Pilih tingkat aktivitasmu</h4>
        <div class="tdeeSelector">
          <div class="tdeeItem left"
            :class="{selected: tdee === 'Sedentary'}"
            v-on:click="selectTdee('Sedentary')">
            <h4>Sedentary</h4>
            <p>Little or no exercise,
              desk job</p>
            <div class="divider"></div>
            <p>Tidak ada atau sedikit
              olahraga, bekerja di meja</p>
          </div>
          <div class="tdeeItem"
            :class="{selected: tdee === 'Lightly Active'}"
            v-on:click="selectTdee('Lightly Active')">
            <h4>Lightly Active</h4>
            <p>Light exercise / sports 1-3 days a week</p>
            <div class="divider"></div>
            <p>Olahraga ringan 1-3 hari per minggu</p>
          </div>
          <div class="tdeeItem left"
            :class="{selected: tdee === 'Moderately Active'}"
            v-on:click="selectTdee('Moderately Active')">
            <h4>Moderately Active</h4>
            <p>Moderate exercise / sports 6-7 days a week</p>
            <div class="divider"></div>
            <p>Olahraga sedang, 6-7 hari per minggu</p>
          </div>
          <div class="tdeeItem"
            :class="{selected: tdee === 'Very Active'}"
            v-on:click="selectTdee('Very Active')">
            <h4>Very Active</h4>
            <p>Hard exercise every day, or exercising 2 times a day</p>
            <div class="divider"></div>
            <p>Olahraga berat setiap hari atau berolahraga 2 kali per hari</p>
          </div>
          <div class="tdeeItem left"
            :class="{selected: tdee === 'Extra Active'}"
            v-on:click="selectTdee('Extra Active')">
            <h4>Extra Active</h4>
            <p>Hard exercise 2 or more times per day,
              or training for marathon, or triathlon, etc</p>
            <div class="divider"></div>
            <p>Olahraga berat 2 kali atau lebih per hari atau berlatih
              untuk marathon, triathlon, dsb</p>
          </div>
        </div>
      </div>
      <div class="aboCnt">
        TDEE untuk tipe <b>{{tdee}}</b> adalah
        <span>{{tdeeNumberLabel}} kalori</span>
      </div>
      <button class="btn primary block"
        :class="{btnLoading: formLoading}">
        <span v-if="$route.query.tab">Simpan Perubahan</span>
        <span v-else>Berikutnya</span></button>
    </form>
    <form v-on:submit.prevent="handleSubmit"
      v-else-if="st === 5" class="st5">
      <div class="pageLoading" v-if="loadingPhotoHistory"></div>
      <div v-else>
        <div class="tdeeCnt">
          <div class="uploadHeader">
            <h4>Upload Foto</h4>
            <div class="uploadInfo">
              Foto tampak depan dan samping full body.
              Disarankan menggunakan baju/kaos yang sama
              untuk foto before & after.
              <p>Point yang di dapat: <b>50</b></p>
            </div>
            <div class="warning">
              Kamu tidak akan mendapat point dan tidak akan menjadi
              finisher jika melewati upload foto.
            </div>
          </div>
          <div class="tdeeSelector">
            <div class="tdeeItem upload left"
              :class="{uploading: uploadingDepan, hasError: photoDepanErr,
              hasPhoto: photoDepan}"
              v-on:click="$refs.fileDepan.click()"
              :style="{'background-image': `url(${photoDepan})`}">
              <h4>Upload<br />Foto Depan</h4>
              <div class="errorLabel" v-if="photoDepanErr">{{photoDepanErr}}</div>
            </div>
            <div class="tdeeItem upload mid"
              :class="{uploading: uploadingBelakang, hasError: photoBelakangErr,
              hasPhoto: photoBelakang}"
              v-on:click="$refs.fileBelakang.click()"
              :style="{'background-image': `url(${photoBelakang})`}">
              <h4>Upload<br />Foto Belakang</h4>
              <div class="errorLabel" v-if="photoBelakangErr">{{photoBelakangErr}}</div>
            </div>
            <div class="tdeeItem upload right"
              :class="{uploading: uploadingSamping, hasError: photoSampingErr,
              hasPhoto: photoSamping}"
              v-on:click="$refs.fileSamping.click()"
              :style="{'background-image': `url(${photoSamping})`}">
              <h4>Upload<br />Foto Samping</h4>
              <div class="errorLabel" v-if="photoSampingErr">{{photoSampingErr}}</div>
            </div>
            <div class="tdeeItem upload foto360"
              :class="{uploading: uploading360, hasError: photo360Err,
              hasPhoto: photo360}"
              v-on:click="$refs.file360.click()"
              :style="{'background-image': `url(${photo360})`}">
              <h4>Upload<br />Foto 360</h4>
              <div class="errorLabel" v-if="photo360Err">{{photo360Err}}</div>
            </div>
          </div>
        </div>
        <button class="btn primary block"
          :class="{btnLoading: formLoading}">
          <span v-if="$route.query.tab">Simpan Perubahan</span>
          <span v-else>Berikutnya</span></button>
      </div>
    </form>
    <div class="nameFormCnt">
      <form class="nameForm" v-on:submit.prevent="handleSubmit">
        <div :class="{fieldGroup: true, hasError: form.gender.error}" v-if="st === 1">
          <label>Jenis Kelamin kamu</label>
          <select class="field" v-model="form.gender.model"
            v-on:change="fieldChanged('gender')">
            <option value="none">Jenis Kelamin</option>
            <option value="male">Laki-laki</option>
            <option value="female">Perempuan</option>
          </select>
          <div class="fieldError" v-if="form.gender.error">{{form.gender.error}}</div>
        </div>
        <div class="fieldGroup" v-else-if="st === 2">
          <label>Tanggal Lahir</label>
          <p class="birthDateInfo">Klik kotak hijau untuk memilih tanggal
            lahir yang kamu inginkan.</p>
          <DatePicker title-position="left" is-expanded
            v-model="pt" mode="date" timezone=""></DatePicker>
        </div>
        <div v-else-if="st === 3">
          <div :class="{fieldGroup: true, hasError: form.w.error}">
            <div class="fieldCnt">
              <input type="number" class="field" placeholder="Berat Badan"
                v-model="form.w.model" v-on:input="fieldChanged('w')">
              <div class="suffix">Kg</div>
            </div>
            <div class="fieldError" v-if="form.w.error">{{form.w.error}}</div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.h.error}">
            <div class="fieldCnt">
              <input type="number" class="field" placeholder="Tinggi Badan"
                v-model="form.h.model" v-on:input="fieldChanged('h')">
              <div class="suffix">Cm</div>
            </div>
            <div class="fieldError" v-if="form.h.error">{{form.h.error}}</div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.v.error}">
            <div class="fieldCnt">
              <input type="number" class="field" placeholder="Lingkar Pinggang"
                v-model="form.v.model" v-on:input="fieldChanged('v')">
              <div class="suffix">Cm</div>
            </div>
            <div class="fieldError" v-if="form.v.error">{{form.v.error}}</div>
          </div>
          <div class="aboCnt bmi">
            Body Mass Index
            <span>{{bmi}}</span>
            <span class="spanLabel" v-if="bmiLabel && bmiLabel !== ''">{{bmiLabel}}</span>
          </div>
        </div>
        <button class="btn primary block" v-if="st < 4"
          :class="{btnLoading: formLoading, disabled: (form.gender.model === 'none' && st === 1)
          || (!pt && st === 2)}">
          <span v-if="$route.query.tab">Simpan Perubahan</span>
          <span v-else>Berikutnya</span></button>
      </form>
    </div>
    <input type="file" ref="fileDepan"
      accept="image/png,image/x-png,image/jpeg,image/jpg"
      v-on:change="handleFileDepan"
      style="display: none">
    <input type="file" ref="fileBelakang"
      accept="image/png,image/x-png,image/jpeg,image/jpg"
      v-on:change="handleFileBelakang"
      style="display: none">
    <input type="file" ref="fileSamping"
      accept="image/png,image/x-png,image/jpeg,image/jpg"
      v-on:change="handleFileSamping"
      style="display: none">
    <input type="file" ref="file360"
      accept="image/png,image/x-png,image/jpeg,image/jpg"
      v-on:change="handleFile360"
      style="display: none">
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { DatePicker, Confirmation },
  data() {
    return {
      st: 1,
      pt: null,
      tdee: 'Sedentary',
      bmiNumber: 0,
      bmi: '. . .',
      form: {
        gender: { model: 'none', error: null },
        w: { model: '', error: null },
        h: { model: '', error: null },
        v: { model: '', error: null },
      },
      selectedChar: 'nunu',
      formLoading: false,
      bmr: '. . .',
      bmrNumber: 0,
      bmiLabel: '',
      tdeeNumber: 0,
      tdeeNumberLabel: '. . .',

      bmiType: 'normal',

      /**
       * Photo
       *
       */
      loadingPhotoHistory: true,
      photoHistory: null,

      uploadingDepan: false,
      uplPrgDepan: 0,
      photoDepanErr: false,
      photoDepan: null,

      uploadingSamping: false,
      uplPrgSamping: 0,
      photoSampingErr: false,
      photoSamping: null,

      uploadingBelakang: false,
      uplPrgBelakang: 0,
      photoBelakangErr: false,
      photoBelakang: null,

      uploading360: false,
      uplPrg360: 0,
      photo360Err: false,
      photo360: null,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
    calculateSize(img, maxWidth, maxHeight) {
      let { width } = img;
      let { height } = img;
      if (width > height) {
        // eslint-disable-next-line
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
      } else {
        // eslint-disable-next-line
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
      }
      return [width, height];
    },
    compressImg(file, next) {
      const blobURL = URL.createObjectURL(file);
      const img = new Image();
      img.src = blobURL;
      img.onerror = () => {
        URL.revokeObjectURL(this.src);
      };
      img.onload = () => {
        URL.revokeObjectURL(this.src);
        const [newWidth, newHeight] = this.calculateSize(img, 1400, 1400);
        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        canvas.id = 'canvastmp';
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        canvas.toBlob((blob) => {
          next(new File([blob], file.name));
          setTimeout(() => {
            document.getElementById('canvastmp').remove();
          });
        }, 'image/jpeg', 0.7);
        document.getElementById('root').append(canvas);
      };
    },
    handleFileDepan() {
      if (!this.photoHistory) return;
      this.photoDepanErr = null;
      this.uploadingDepan = true;
      const [rawFile] = this.$refs.fileDepan.files;
      if (!rawFile) return;
      this.compressImg(rawFile, (file) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('label', 'depan');
        if (this.$route.query.contentId) formData.append('contentId', this.$route.query.contentId);
        this.$http.post(this.$config.uri(`content/photo/history/${this.photoHistory.id}/add`), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // Display progress in chat
          },
        }).then((r) => {
          this.uploadingDepan = false;
          if (r.data.status !== 200) {
            const msg = (r.data.message) ? r.data.message : 'Upload foto gagal!';
            this.photoDepanErr = msg;
            return;
          }
          this.photoDepan = r.data.uri;
        });
      });
    },
    handleFileBelakang() {
      if (!this.photoHistory) return;
      this.photoBelakangErr = null;
      this.uploadingBelakang = true;
      const [rawFile] = this.$refs.fileBelakang.files;
      if (!rawFile) return;
      this.compressImg(rawFile, (file) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('label', 'belakang');
        if (this.$route.query.contentId) formData.append('contentId', this.$route.query.contentId);
        this.$http.post(this.$config.uri(`content/photo/history/${this.photoHistory.id}/add`), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // Display progress in chat
          },
        }).then((r) => {
          this.uploadingBelakang = false;
          if (r.data.status !== 200) {
            const msg = (r.data.message) ? r.data.message : 'Upload foto gagal!';
            this.photoBelakangErr = msg;
            return;
          }
          this.photoBelakang = r.data.uri;
        });
      });
    },
    handleFileSamping() {
      if (!this.photoHistory) return;
      this.photoSampingErr = null;
      this.uploadingSamping = true;
      const [rawFile] = this.$refs.fileSamping.files;
      if (!rawFile) return;
      this.compressImg(rawFile, (file) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('label', 'samping');
        if (this.$route.query.contentId) formData.append('contentId', this.$route.query.contentId);
        this.$http.post(this.$config.uri(`content/photo/history/${this.photoHistory.id}/add`), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // Display progress in chat
          },
        }).then((r) => {
          this.uploadingSamping = false;
          if (r.data.status !== 200) {
            const msg = (r.data.message) ? r.data.message : 'Upload foto gagal!';
            this.photoSampingErr = msg;
            return;
          }
          this.photoSamping = r.data.uri;
        });
      });
    },
    handleFile360() {
      if (!this.photoHistory) return;
      const [rawFile] = this.$refs.file360.files;
      if (!rawFile) return;
      this.compressImg(rawFile, (file) => {
        this.uploading360 = true;
        const formData = new FormData();
        formData.append('image', file);
        formData.append('label', '360');
        if (this.$route.query.contentId) formData.append('contentId', this.$route.query.contentId);
        this.$http.post(this.$config.uri(`content/photo/history/${this.photoHistory.id}/add`), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // Display progress in chat
          },
        }).then((r) => {
          this.uploading360 = false;
          if (r.data.status !== 200) {
            const msg = (r.data.message) ? r.data.message : 'Upload foto gagal!';
            this.photo360Err = msg;
            return;
          }
          this.photo360 = r.data.uri;
        });
      });
    },
    goBack() {
      if (this.$route.query.tab === 'birthdate'
        || this.$route.query.tab === 'bmi'
        || this.$route.query.tab === 'bmr'
        || this.$route.query.bodycomposition === 'y'
        || this.$route.query.upload === 'y') {
        window.history.back();
      }
      if (this.st <= 1) window.history.back();
      else this.st -= 1;
    },
    selectTdee(tdee) {
      this.tdee = tdee;
      this.calcBmr();
    },
    fieldChanged(field) {
      this.form[field].error = null;
      switch (field) {
        case 'h':
        case 'w':
        case 'v':
          this.calcBmi();
          break;
        default: break;
      }
    },
    calcBmi() {
      const f = {
        h: Number(this.form.h.model),
        w: Number(this.form.w.model),
        v: Number(this.form.v.model),
      };
      if (f.h > 0 && f.w > 0) {
        this.bmiNumber = f.w / ((f.h / 100) ** 2);
        if (this.bmiNumber < 17) {
          this.bmiType = 'kurus';
          this.bmiLabel = 'Kekurangan berat badan tingkat berat';
        } else if (this.bmiNumber < 18.5) {
          this.bmiType = 'kurus';
          this.bmiLabel = 'Kekurangan berat badan tingkat ringan';
        } else if (this.bmiNumber < 25.1) {
          this.bmiType = 'normal';
          this.bmiLabel = 'Normal';
        } else if (this.bmiNumber < 27) {
          this.bmiType = 'gemuk';
          this.bmiLabel = 'Kelebihan berat badan tingkat ringan';
        } else {
          this.bmiType = 'gemuk';
          this.bmiLabel = 'Kelebihan berat badan tingkat berat';
        }
        this.bmi = `${this.bmiNumber.toLocaleString('id', { maximumFractionDigits: 2 })}`;
      } else {
        this.bmi = '. . .';
      }
    },
    doSave() {
      if (this.formLoading) return;
      this.formLoading = true;
      setTimeout(() => {
        this.formLoading = false;
        this.$router.push('/main');
      }, 1200);
    },
    calcBmr() {
      const f = {
        h: Number(this.form.h.model),
        w: Number(this.form.w.model),
        v: Number(this.form.v.model),
      };
      const d = new Date();
      const age = d.getFullYear() - this.pt.getFullYear();
      this.bmrNumber = (this.form.gender.model === 'male')
        ? 66 + (13.7 * f.w) + (5 * f.h) - (6.8 * age)
        : 655 + (9.6 * f.w) + (1.8 * f.h) - (4.7 * age);
      this.bmr = (!this.bmrNumber || this.bmrNumber <= 0)
        ? '. . .' : this.bmrNumber.toLocaleString('id', { maximumFractionDigits: 2 });
      if (this.bmr === '. . .') {
        this.tdeeNumberLabel = '. . .';
        return;
      }
      switch (this.tdee) {
        case 'Sedentary':
          this.tdeeNumber = this.bmrNumber * 1.2;
          break;
        case 'Lightly Active':
          this.tdeeNumber = this.bmrNumber * 1.375;
          break;
        case 'Moderately Active':
          this.tdeeNumber = this.bmrNumber * 1.55;
          break;
        case 'Very Active':
          this.tdeeNumber = this.bmrNumber * 1.725;
          break;
        case 'Extra Active':
          this.tdeeNumber = this.bmrNumber * 1.9;
          break;
        default: break;
      }
      this.tdeeNumberLabel = this.tdeeNumber.toLocaleString('id', { maximumFractionDigits: 2 });
    },
    saveBmr(next) {
      this.$session.set('bk6_bmr', this.bmrNumber);
      this.$session.set('bk6_tdee', this.tdeeNumber);
      this.$session.set('bk6_tdeeType', this.tdee);
      this.$http.post(this.$config.uri('user/set/bmr'), {
        bmr: this.bmrNumber,
        tdee: this.tdeeNumber,
        tdeeType: this.tdee,
      }).then((r) => {
        if (next) next(r);
      });
    },
    handleSubmit() {
      if (this.formLoading) return;
      if (this.st === 1) {
        if (this.form.gender.model === 'none') {
          this.form.gender.error = 'Mohon pilih jenis kelamin untuk melanjutkan.';
          return;
        }
        this.$session.set('bk6_gender', this.form.gender.model);
        this.$http.post(this.$config.uri('user/set/gender'), {
          gender: this.form.gender.model,
        }).then((r) => {
          if (this.$route.query.tab === 'gender') {
            this.calcBmr();
            this.saveBmr(() => {
              window.history.back();
            });
          }
        });
      } else if (this.st === 2) {
        if (!this.pt) return;
        this.$session.set('bk6_birthdate', Math.floor(this.pt.getTime() / 1000));
        this.$http.post(this.$config.uri('user/set/birthdate'), {
          birthdate: Math.floor(this.pt.getTime() / 1000),
        }).then((r) => {
          if (this.$route.query.tab === 'birthdate') {
            this.calcBmr();
            this.saveBmr(() => {
              window.history.back();
            });
          }
        });
      } else if (this.st === 3) {
        const f = {
          h: Number(this.form.h.model),
          w: Number(this.form.w.model),
          v: Number(this.form.v.model),
        };
        if (f.w < 1) {
          this.form.w.error = 'Masukan berat badan kamu untuk melanjutkan.';
          return;
        }
        if (f.h < 1) {
          this.form.h.error = 'Masukan tinggi badan kamu untuk melanjutkan.';
          return;
        }
        if (f.v < 1) {
          this.form.v.error = 'Masukan lingkar pinggang kamu untuk melanjutkan.';
          return;
        }
        this.$session.set('bk6_bodyWeight', f.w);
        this.$session.set('bk6_bodyHeight', f.h);
        this.$session.set('bk6_waistSize', f.v);
        this.$session.set('bk6_bmi', this.bmiNumber);
        this.$session.set('bk6_bmiType', this.bmiType);
        this.$http.post(this.$config.uri('user/set/bmi'), {
          bodyWeight: f.w,
          bodyHeight: f.h,
          waistSize: f.v,
          bmi: this.bmiNumber,
          bmiType: this.bmiType,
        }).then((r) => {
          if (this.$route.query.tab === 'bmi' || this.$route.query.bodycomposition === 'y') {
            this.calcBmr();
            this.formLoading = true;
            this.saveBmr(() => {
              if (this.$route.query.bodycomposition === 'y') {
                this.$http.post(this.$config.uri('content/photo/history'), {
                  bodyHeight: this.$session.get('bk6_bodyHeight'),
                  bodyWeight: this.$session.get('bk6_bodyWeight'),
                  waistSize: this.$session.get('bk6_waistSize'),
                  bmi: this.$session.get('bk6_bmi'),
                  bmiType: this.$session.get('bk6_bmiType'),
                  bmr: this.$session.get('bk6_bmr'),
                  tdee: this.$session.get('bk6_tdee'),
                  tdeeType: this.$session.get('bk6_tdeeType'),
                  contentId: this.$route.query.contentId,
                }).then(() => {
                  window.history.back();
                });
                return;
              }
              window.history.back();
            });
          }
        });
        if (this.$route.query.tab === 'bmi' || this.$route.query.bodycomposition === 'y') {
          return;
        }
      } else if (this.st === 4) {
        this.saveBmr(() => {
          if (this.$route.query.tab === 'bmr') window.history.back();
        });
      }
      this.formLoading = true;
      if (this.$route.query.tab) return;
      setTimeout(() => {
        this.formLoading = false;
        if (this.st === 4) {
          this.$http.post(this.$config.uri('content/photo/history'), {
            bodyHeight: this.$session.get('bk6_bodyHeight'),
            bodyWeight: this.$session.get('bk6_bodyWeight'),
            waistSize: this.$session.get('bk6_waistSize'),
            bmi: this.$session.get('bk6_bmi'),
            bmiType: this.$session.get('bk6_bmiType'),
            bmr: this.$session.get('bk6_bmr'),
            tdee: this.$session.get('bk6_tdee'),
            tdeeType: this.$session.get('bk6_tdeeType'),
          }).then((r) => {
            this.photoHistory = (r.data.status === 200) ? r.data.data : null;
            this.loadingPhotoHistory = false;
          });
        } else if (this.st >= 5) {
          if (!this.photoDepan || !this.photoSamping) {
            this.$refs.confirmDialog.open({
              title: 'Foto tidak lengkap',
              desc: `Apakah kamu yakin ingin melanjutkan tanpa melengkapi foto?
                Proses upload foto ini tidak dapat di ulang kembali.`,
              action: 'Lanjutkan',
            }, (b) => {
              if (!b) return;
              if (this.$route.query.upload === 'y') {
                window.history.back();
                return;
              }
              this.$router.push('/t-shirt/size');
            });
          } else {
            if (this.$route.query.upload === 'y') {
              window.history.back();
              return;
            }
            this.$router.push('/t-shirt/size');
          }
          return;
        }
        this.st += 1;
        if (this.st === 4) this.calcBmr();
      }, 100);
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
    this.selectedChar = this.$session.get('bk6_character') || 'nunu';
    this.form.gender.model = this.$session.get('bk6_gender') || 'none';
    const birthdate = this.$session.get('bk6_birthdate');
    if (birthdate) this.pt = new Date(birthdate * 1000);
    this.form.h.model = this.$session.get('bk6_bodyHeight');
    this.form.w.model = this.$session.get('bk6_bodyWeight');
    this.form.v.model = this.$session.get('bk6_waistSize');
    this.bmiType = this.$session.get('bk6_bmiType') || 'normal';
    this.calcBmi();
    if (this.$route.query.tab === 'birthdate') {
      this.st = 2;
    } else if (this.$route.query.tab === 'bmi') {
      this.st = 3;
    } else if (this.$route.query.tab === 'bmr') {
      this.st = 4;
      this.calcBmr();
    } else if (this.$route.query.bodycomposition === 'y') {
      this.st = 3;
    } else if (this.$route.query.upload === 'y') {
      this.photoHistory = { id: this.$route.query.historyId };
      this.loadingPhotoHistory = false;
      this.st = 5;
    }
  },
};
</script>

<style scoped lang="scss">
.birthDateInfo{
  font-size: 14px;
  margin: 0 0 10px 7px;
  line-height: 1.2;
  color: #444;
}
.bdArrow{
  width: 20px; height: 20px;
  background-image: url(../assets/arrow-down.png);
  background-size: cover;
  margin: 0 0 10px 60px;
}

.pageLoading{
  position: fixed;
  left: 0; right: 0; bottom: 100px; top: 100px;
  background-image: url(../assets/loading.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 54px auto;
}

.section{
  padding: 30px 0;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 768px) {
    min-height: calc(100vh - 60px);
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 24px;
    margin: 0 0 20px;
    text-align: left;
  }
  .header{
    padding: 16px 20px 0;
    margin: -30px 0 0;
    position: relative;
    z-index: 9;
    display: flex;
    @media (min-width: 480px) {
      padding-left: 0;
      padding-right: 0;
    }
    .backBtn{
      width: 46px; height: 46px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-back.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 9;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 22px;
      margin: 11px 0 0 20px;
    }
  }
  .charThumbCnt{
    display: flex;
    margin: 0 0 20px;
    .charThumb{
      width: calc(50% - 10px);
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #006519;
      .charImg{
        height: 54px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 10px;
        margin-bottom: 4px;
        border: #78C90E 4px solid;
      }
      &.inactive{
        color: #999;
        .charImg{
          border-color: #ccc;
          filter: grayscale(1);
        }
      }
      &.nunu{
        margin-right: auto;
        .charImg{
          background-image: url(../assets/profile-nunu.png);
        }
      }
      &.lili{
        margin-left: auto;
        .charImg{
          background-image: url(../assets/profile-lili.png);
        }
      }
    }
  }
  .mainChar{
    // background-image: url(../assets/game-bg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 7px;
    position: absolute;
    top: 186px; bottom: 160px;
    left: 20px; right: 20px;
    .theChar{
      position: absolute;
      left: 0; right: 0; top: 24px; bottom: 30px;
      background-image: url(../assets/nunu-iddle.png);
      background-position: bottom center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}

.aboCnt{
  margin-bottom: 20px;
  // box-shadow: 2px 2px 4px rgba(0,0,0,.1);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  padding: 10px 16px;
  font-size: 14px;
  color: #767676;
  border-radius: 7px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, .5);
  // background-color: #f1eeca;
  &.bmi{
    span{
      margin-top: 2px;;
    }
  }
  span{
    display: block;
    font-size: 20px;
    border-radius: 3px;
    font-weight: bold;
    color: #444;
  }
  span.spanLabel{
    display: block;
    font-weight: normal;
    font-size: 15px;
    margin-top: -1px;
  }
}

.tdeeCnt{
  padding-bottom: 16px;
  h4{
    color: #444;
    font-size: 18px;
    margin: 0 10px 6px;
  }
  .uploadHeader{
    padding-right: 120px;
    background-image: url(../assets/upload-example.png);
    background-size: 100px auto;
    background-position: right top;
    background-repeat: no-repeat;
    h4{
      margin-left: 0;
    }
    .uploadInfo{
      font-size: 14px;
      p{
        margin: 10px 0;
      }
    }
    .warning{
      color: #ea9700;
      background-color: #ffffe8;
      padding: 8px 10px;
      font-size: 13px;
      border: #ffd17e 1px solid;
      margin-bottom: 20px;
      border-radius: 3px;
      padding-left: 48px;
      position: relative;
      @media (max-width: 680px) {
        margin-right: -120px;
      }
      &:before{
        content: "";
        position: absolute;
        left: 10px; top: 8px; bottom: 0;
        width: 30px; height: 30px;
        background-image: url(../assets/caution.png);
        background-size: 30px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
  .tdeeSelector{
    display: flex;
    flex-wrap: wrap;
    .tdeeItem{
      width: calc(50% - 5px);
      background-color: #fff;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
      padding: 12px 14px;
      box-sizing: border-box;
      margin-bottom: 10px;
      border-radius: 5px;
      position: relative;
      border: #fff 2px solid;
      cursor: pointer;
      &:hover{
        border-color: #999;
      }
      &:before{
        width: 16px; height: 16px;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/circle-bg-inactive.png);
        background-size: 16px auto;
        content: "";
        opacity: .5;
      }
      &:active{
        background-color: #ddd;
      }
      &.left{
        margin-right: auto;
      }
      .divider{
        border-top: #e5e5e5 1px solid;
        margin-top: 10px;
        padding-bottom: 10px;
      }
      h4{
        font-size: 16px;
        margin: 0 0 8px;
        color: #006519;
      }
      p{
        margin: 0;
        font-size: 13px;
        line-height: 1.1;
      }
      &.selected{
        border-color: #006519;
        &:before{
          background-image: url(../assets/checked-green.png);
          opacity: 1;
        }
      }
      &.upload{
        width: calc(50% - 8px);
        background-color: #fff;
        border: none;
        border-color: #eee;
        padding: 150px 16px 0;
        height: 280px;
        box-sizing: border-box;
        background-position: center;
        background-size: cover;
        margin: 0 0 10px;
        &.right{
          margin-left: auto;
        }
        &.mid{ display: none !important; }
        &.foto360{ display: none !important; }
        @media (max-width: 500px) {
          height: 200px;
          padding: 110px 6px 0;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &.mid{
          margin: 0 auto 10px;
        }
        &:before{
          left: 50%; top: 96px;
          width: 46px; height: 46px;
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url(../assets/upload-image.png);
          margin-left: -23px;
          @media (max-width: 500px) {
            top: 56px;
          }
        }
        h4{
          text-align: center;
          color: #767676;
          font-size: 14px;
          @media (max-width: 500px) {
            font-size: 13px;
          }
        }
        &.hasPhoto{
          h4{ display: none; }
          &:before{ display: none; }
        }
        &.hasError{
          border-color: red;
          box-shadow: none;
          color: red;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 0 10px;
          font-size: 15px;
          background-color: #fff3f3;
          &:before{ display: none; }
          h4{ display: none; }
        }
        &.uploading{
          box-shadow: none;
          background-color: #ddd;
          border-color: #ddd;
          background-image: url(../assets/loading.svg) !important;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 46px auto;
          h4{ display: none; }
          &:before{ display: none; }
        }
      }
    }
  }
}

.st4{
  padding-top: 20px;
  @media (max-width: 480px) {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.st5{
  padding-top: 40px;
  @media (max-width: 480px) {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.charPreview{
  width: auto;
  background-image: url(../assets/nunu-normal.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  left: 150px; right: 0; top: 100px;
  bottom: 260px;
  transition: all .3s ease;
  @media (max-width: 768px) {
    left: 0;
  }
  @media (max-height: 625px) {
    display: none;
  }
  &.kurus{
    background-image: url(../assets/nunu-kurus.png);
  }
  &.gemuk{
    background-image: url(../assets/nunu-gemuk.png);
  }
  &.lili{
    &.normal{
      background-image: url(../assets/lili-normal.png);
    }
    &.kurus{
      background-image: url(../assets/lili-kurus.png);
    }
    &.gemuk{
      background-image: url(../assets/lili-gemuk.png);
    }
  }
  &.st2{
    bottom: 400px; top: 40px;
  }
  &.st3{
    bottom: 380px; top: 40px;
  }
}
.accCnt{
  margin: 0 0 26px;
  h5{
    margin: 0 7px 6px;
    text-align: left;
    font-size: 16px;
    color: #555;
  }
  .theAcc{
    display: flex;
    .accItem{
      width: 60px;
      height: 60px;
      background-color: #addc91;
      margin-right: 10px;
      border-radius: 12px;
      box-sizing: border-box;
      &.disabled{
        background-color: #ccc;
        color: #767676;
        font-size: 11px;
        padding-top: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
}

.nameFormCnt{
  position: fixed;
  left: 150px; right: 0; bottom: 0;
  @media (max-width: 768px) {
    left: 0;
  }
  @media (max-height: 625px) {
    position: static;
  }
}
.nameForm{
  position: absolute;
  bottom: 40px; width: 460px;
  left: 50%; margin-left: -230px;
  @media (max-width: 500px) {
    left: 20px; right: 20px;
    width: auto; margin: 0;
  }
  @media (max-height: 625px) {
    position: static;
    margin: 0;
  }
}
</style>
